import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

/** Matches `MainContent` in App.styled.ts */
const mainContentMaxWidthPx = 768;

const slideUp = keyframes`
  from {
    transform: translateX(-50%) translateY(100%);
  }
  to {
    transform: translateX(-50%) translateY(0);
  }
`;

/** Tap outside the sheet to close. */
export const StyledSheetBackdrop = styled.div`
  position: fixed;
  inset: 0;
  border: none;
  padding: 0;
  margin: 0;
  background: rgba(18, 34, 67, 0.45);
  z-index: 1000;
  cursor: pointer;
  animation: ${fadeIn} 0.2s ease;
`;

export const StyledSheetPanel = styled.div`
  position: fixed;
  left: 50%;
  bottom: 0;
  z-index: 1001;
  width: 100%;
  max-width: ${mainContentMaxWidthPx}px;
  box-sizing: border-box;
  background: #ffffff;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  padding: 20px 20px calc(28px + env(safe-area-inset-bottom, 0px));
  max-height: 78vh;
  overflow-y: auto;
  box-shadow: 0 -8px 32px rgba(18, 34, 67, 0.18);
  animation: ${slideUp} 0.25s ease forwards;

  .sheet-title {
    margin: 0 0 16px;
    font-family: "Noto Sans Hebrew", sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 16px;
    letter-spacing: -0.22px;
    text-align: center;
    color: #122243;
  }

  /* 1px gradient “border” + radius: border-image ignores border-radius, so we use background-clip. */
  .sheet-body-box {
    margin-bottom: 20px;
    border: 1px solid transparent;
    border-radius: 10px;
    box-sizing: border-box;
    background-image:
      linear-gradient(#f0f2f6, #f0f2f6),
      linear-gradient(0deg, #004ef7 0%, #00eab2 100%);
    background-origin: border-box;
    background-clip: padding-box, border-box;

    .sheet-body-inner {
      padding: 18px 16px;
      min-height: 100px;

      .sheet-body-text {
        margin: 0;
        font-family: "Noto Sans Hebrew", sans-serif;
        font-size: 15px;
        line-height: 1.5;
        color: #122243;
        text-align: right;
        white-space: pre-wrap;
        word-break: break-word;
      }
    }
  }
`;
